import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton from '../../../components/Buttons/SaveButton';
import ButtonBar from '../../../components/Fields/ButtonBar';
import Form from '../../../components/Fields/Form';
import { FormConfig } from '../../../components/Fields/Types';
import useValidation from '../../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectUserUpdateModel from '../../../models/ProjectUserUpdateModel';
import DataService from "../../../services/data.service";
import { ProjectProps } from '../../../types/IdProps';
import { DataResult } from '../../../types/Result';
import ProjectUserField from '../Components/ProjectUserField';


const Project_tab_Users: React.FC<ProjectProps> = ({ projectId, projectTypeId }) => {
    const [formData, setFormData] = useState<ProjectUserUpdateModel[]>();
    const [serverErrors, setServerErrors] = useState<DataResult<ProjectUserUpdateModel[]>>({ isSuccesful: true, messages: [], data: [] });
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getFormData();
    }, [projectId]);

    function getFormData() {
        DataService.get<ProjectUserUpdateModel[]>('api/v1/ProjectUsers/ByProject/' + projectId)
            .then(response => {
                setFormData(response);
            })
            .catch(e => { handleException(e); });
    }

    function submit() {
        if (formData) {
            DataService
                .put<DataResult<ProjectUserUpdateModel[]>>(`api/v1/ProjectUsers/UpdateCollection`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        showErrors: 'always',
    };

    if (formData) {
        formData.forEach((projectUser, index) => {
            if (projectUser.isRequired) {
                formConfig.fields.push({ name: index + '.userIds', label: projectUser.functionalRole.name, validationRules: [{ type: 'isRequired' }] });
            } else {
                formConfig.fields.push({ name: index + '.userIds', label: projectUser.functionalRole.name });
            }
        });
    }

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!formData)
        return null;

    var fields = formData.map((projectUser: ProjectUserUpdateModel, index: number) => {
        return <ProjectUserField {...getFieldProps(index + '.userIds')} projectUser={projectUser} key={index} />
    });

    return (
        <Form title='Project team' footer={(
            <Row>
                <Col>
                    <ButtonBar offset={2}>
                        <Authorize applicationFunction={ApplicationFunctions.UpdateProject} projectTypeId={projectTypeId}>
                            <SaveButton  {...getSubmitButtonProps()} />
                        </Authorize>
                    </ButtonBar>
                </Col>
            </Row>
            )}>
            {fields}
        </Form>
    );
}
export default Project_tab_Users;